import { CloudOff, RotateCw } from 'lucide-react';
import { useI18n } from '../lib/i18n';

/**
 * Lo que se pinta donde iba la lista cuando la lista NO se pudo traer.
 *
 * Deliberadamente NO se parece al vacío de "acá no hay nada": el vacío es una respuesta sobre el
 * trabajo ("estás al día") y esto es una respuesta sobre el app ("no pude preguntar"). Confundir
 * los dos es lo que hace que una cola rota se vea como una cola al día y nadie la trabaje.
 */
export function NoCargo({ onRetry, compact }: { onRetry?: () => void; compact?: boolean }) {
  const { t } = useI18n();
  return (
    <div className={compact ? 'nocargo nocargo-compact' : 'nocargo'} role="status">
      <CloudOff size={compact ? 14 : 18} aria-hidden />
      <span className="nocargo-msg">{t('load.failed', { what: t('load.what.datos') })}</span>
      {onRetry && (
        <button type="button" className="nocargo-btn" onClick={onRetry}>
          <RotateCw size={12} aria-hidden /> {t('common.retry')}
        </button>
      )}
    </div>
  );
}
